import { render, staticRenderFns } from "./IconProfileBold.vue?vue&type=template&id=05f2d498&scoped=true&"
import script from "./IconProfileBold.vue?vue&type=script&lang=js&"
export * from "./IconProfileBold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f2d498",
  null
  
)

export default component.exports